export default [{ name: 'km' }, { name: 'tg' }, { name: 'eb' }];
